import { render, staticRenderFns } from "./kitchen.vue?vue&type=template&id=a01ed2e2"
import script from "./kitchen.vue?vue&type=script&lang=js"
export * from "./kitchen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports